var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-layout',{attrs:{"retailer-id":_vm.navRetailerId,"active-menu-item":"newdashboard"}},[_c('main-column',{attrs:{"content-class":"main-column-sub-columns columns fullHeight"}},[_c('i-frame',{attrs:{"src":_vm.src}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }